/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ type: NonNullable<unknown> }} Extension_Popup_Currentpage_Trackedwithtype3Inputs */

const he_extension_popup_currentpage_trackedwithtype3 = /** @type {(inputs: Extension_Popup_Currentpage_Trackedwithtype3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`במעקב: ${i?.type}`)
};

const en_extension_popup_currentpage_trackedwithtype3 = /** @type {(inputs: Extension_Popup_Currentpage_Trackedwithtype3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tracked: ${i?.type}`)
};

/**
* | output |
* | --- |
* | "Tracked: {type}" |
*
* @param {Extension_Popup_Currentpage_Trackedwithtype3Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const extension_popup_currentpage_trackedwithtype3 = /** @type {((inputs: Extension_Popup_Currentpage_Trackedwithtype3Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extension_Popup_Currentpage_Trackedwithtype3Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_extension_popup_currentpage_trackedwithtype3(inputs)
	return en_extension_popup_currentpage_trackedwithtype3(inputs)
});
export { extension_popup_currentpage_trackedwithtype3 as "extension_popup_currentPage_trackedWithType" }